import useCurrencies from "core/hooks/useCurrencies";

const Amount = ({
    value,
    currencyCode
}) => {

    const { formatAmount } = useCurrencies();

    if(value < 0){
        return (
            <span className="rt--error-text">
                { formatAmount(value, currencyCode) }
            </span>
        )
    }

    return formatAmount( value , currencyCode);
}

export default Amount;